export const commonConstants = {
    forgotPassword: {
        title: 'Select your new password. The requirements are listed below',
        authCode: {
            header: 'Please enter the authentication code you have been sent.',
            body: 'If the authentication code fails to arrive, click to resend via email'
        },
        rule: 'You cannot choose from one of your last five passwords'
    }
}